module.exports = __webpack_public_path__ + "img/bg_img02.80047c83.png";